import { getEdgeTrace } from '../edge-trace';
import { CONSENT_GEO_KEY } from './consent-geo-key';
import { EU_EEA_UK_COUNTRIES } from './eu-countries';

export async function resolveGeoConsentRequired(): Promise<boolean> {
  if (typeof window === 'undefined') {
    return true;
  }
  const stored = safeRead();
  if (stored !== null) {
    return stored === '1';
  }
  const { country } = await getEdgeTrace();
  if (!country) {
    return true;
  }
  const required = EU_EEA_UK_COUNTRIES.includes(country);
  safeWrite(required ? '1' : '0');
  return required;
}

function safeRead(): string | null {
  try {
    return localStorage.getItem(CONSENT_GEO_KEY);
  } catch {
    return null;
  }
}

function safeWrite(value: string): void {
  try {
    localStorage.setItem(CONSENT_GEO_KEY, value);
  } catch {}
}
